type CourierNameFields = Pick<Users, "surname" | "given_name" | "prefix">;

/**
 * Formats a courier display name from known name fields.
 *
 * Args:
 *   courier: Optional name fields used to build the display string.
 *
 * Returns:
 *   A formatted "SURNAME, Given Prefix" string, with empty segments for
 *   missing fields.
 */
export const formatCourierName = (
  courier?: CourierNameFields | null
): string =>
  `${courier?.surname?.toUpperCase() ?? ""}, ${courier?.given_name ?? ""} ${
    courier?.prefix ?? ""
  }`;
